<div class="globalWrapper flex flex-column justify-content-between" style="min-height: 100dvh">
  <div class="sticky-custom" style="min-height: 84px">
    <app-header [isPrivate]="false"></app-header>
  </div>
  <router-outlet></router-outlet>
  @if(!isMobile || (isMobile && (isLoggedIn$ | async))) {
  <app-footer></app-footer>
  } @if(isMobile && (isLoggedIn$ | async)) {
  <div class="sticky-custom bottom">
    <app-mobile-nav></app-mobile-nav>
  </div>
  }
</div>
